module.exports = __webpack_public_path__ + "img/gbp.dac906ac.svg";